import svgIcon from '@/components/SvgIcon/index.vue'; // 引入刚才新建的svg组件
import Vue from 'vue';
Vue.component('svg-icon', svgIcon) // 全局组件
const req = require.context('@/assets/icons', false, /\.svg$/) // ./svg，就是我们放svg图标的文件名
const requireAll = requireContext =>
  requireContext.keys().map(requireContext)
requireAll(req)
